import { render, staticRenderFns } from "./EditServer.vue?vue&type=template&id=2d125794&"
import script from "./EditServer.vue?vue&type=script&lang=js&"
export * from "./EditServer.vue?vue&type=script&lang=js&"
import style0 from "./EditServer.vue?vue&type=style&index=0&id=2d125794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports